import datePicker from 'vue-bootstrap-datetimepicker';

Vue.component('manage-campaign', {
    props: [
    	'clients'
    ],

	data () {
		return {
            config: {},
            loading: false,
            campaigns: []
		}
	},

	mounted () {
		$('#manage-campaign').on('shown.bs.modal', () => {
			this.fetchConfig();
			this.fetchCampaigns();
		});
	},

	methods: {
		fetchConfig () {
			axios.get('/api/mass-email/templates', {
				params: {
					client_ids: this.clients.filter(c => c.id != 24)
				}
			}).then((response) => {
				this.config = response.data;
				this.loading = false;
			});
		},

		fetchCampaigns () {
			this.loading = true;

			axios.get('/api/campaign', {
				params: {
					client_ids: this.clients.filter(c => c.id != 24)
				}
			}).then((response) => {
				this.campaigns = response.data;
				this.loading = false;
			});
		}
	}
});
